import './GoLiveButton.css';
import { Button } from '../../components/Button';
import { t } from '../../copy/strings';
import { goLive } from '../../state/actions';

export interface GoLiveButtonProps {
  /**
   * Antes de `goLive()`: `hadFocus` diz se o botão tinha o foco. O botão sai do DOM quando o `LiveChip` (não focável)
   * volta, então o dono devolve o foco à trilha (§15.2.2 regra 4: o foco nunca cai no `body`).
   */
  onActivate?: (hadFocus: boolean) => void;
  /** Fase `after` (a apuração acabou): "Voltar ao fim" no lugar de "Voltar ao vivo" (DECISOES §86). */
  closed?: boolean;
}

/**
 * "Voltar ao vivo" (§10.2 `GoLiveButton`): `Button` variante `inverted`, `<button>` nativo com o texto visível como nome;
 * chama `goLive()` (§10.5), que remove o `t` do hash com replace. 124 px fixos (AC-10.2-05); 44 px de altura com
 * ponteiro grosso (regra do `Button`, §15.5.5).
 */
export function GoLiveButton({ onActivate, closed = false }: GoLiveButtonProps) {
  return (
    <span class="go-live-button" data-testid="go-live-button">
      <Button
        label={t(closed ? 'timeline.goEnd' : 'timeline.goLive')}
        variant="inverted"
        onClick={(e: MouseEvent) => {
          onActivate?.(typeof document !== 'undefined' && document.activeElement === e.currentTarget);
          goLive();
        }}
      />
    </span>
  );
}
